export enum CancellationPolicy {
  generous = 1,
  standard = 2,
  rigid = 3,
  custom = 4
}
